import { TabbedButton } from 'components';
import { DateRangeType } from 'enums';

interface DateTabsProps {
    dateRange: DateRangeType;
    setDateRange: (date: DateRangeType) => void;
}

const TabItems = [
    { label: '3 Months', value: DateRangeType.ThreeMonths },
    { label: '6 Months', value: DateRangeType.SixMonths },
    { label: '1 Year', value: DateRangeType.OneYear },
];

export function DateTabs({ dateRange, setDateRange }: DateTabsProps) {

    const handleTabClick = (index: number) => {
        setDateRange(TabItems[index].value);
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }, 0);
    };

    var selectedTab = TabItems.findIndex(tab => tab.value === dateRange);

    return (
        <TabbedButton
            items={TabItems}
            activeIndex={selectedTab}
            onTabClick={handleTabClick}
        />
    );
}